// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2DiQ2","selects":"Documents_selects__OxWGh"};